import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import Timer from 'react-compound-timer';
import styles from './VM.scss';
import {
  ExitToApp as LeaveVM,
  ArrowDropUp as DropUp,
  ErrorOutline as ErrorIcon,
} from '@material-ui/icons';

import Menu from '@material-ui/core/Menu';
import { StyledMenuItem } from '../reusable_components/StyledMenuItem';
import { Spinner } from '../reusable_components/Spinner';
import { updateErrorMsg } from '../../store/action/error';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

const VM = ({
  vmState,
  services,
  task,
  updateErrorMsg,
  errorState,
  deleteErrorMsg,
  countdown,
  partJOined,
  userTelephonyProvider,
  flags,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [leaveButtonLoading, setleaveButtonLoading] = useState(false);
  const [dropupName, setDropupName] = useState('');
  const [dropupType, setDropupType] = useState('');
  const [recordingId, setRecordingId] = useState('');
  const [selectedByAgent, setSelectedByAgent] = useState(false);
  const [showVM, setShowVM] = useState(true);

  if (!task?.default_one_click_vm && flags.enableHideUnselectedOneClickVms) {
    // hide all VMs https://billsdev.atlassian.net/browse/PLATCON-1639
    return <></>;
  }

  let filteredVMs = vmState || [];
  if (userTelephonyProvider === 'genesys') {
    filteredVMs = filteredVMs.filter(vm => vm.voice_hub_ivr_id);
  }

  if (!filteredVMs.length) {
    // no need to display this component is no VM on the list
    return <></>;
  }

  // use filter instead of find because there may be multiple VMs matching the key
  const defaultOneClickVMsByType = filteredVMs.filter(
    vm =>
      vm.vm_type?.toLowerCase() === task?.default_one_click_vm?.toLowerCase()
  );
  const defaultOneClickVMsByDesc = filteredVMs.filter(
    vm => vm.name?.toLowerCase() === task?.default_one_click_vm?.toLowerCase()
  );

  let defaultSelectedVM = null;
  if (defaultOneClickVMsByType.length) {
    if (flags.enableHideUnselectedOneClickVms) {
      // ignore all other VMs
      filteredVMs = defaultOneClickVMsByType;
      defaultSelectedVM = defaultOneClickVMsByType[0];
    } else {
      // display all VMs and preselect the default one
      defaultSelectedVM = defaultOneClickVMsByType[0];
    }
  } else {
    // fallback to default VM by desc if default VM by type doesn't exist
    if (defaultOneClickVMsByDesc.length) {
      if (flags.enableHideUnselectedOneClickVms) {
        // hide all other VMs
        filteredVMs = defaultOneClickVMsByDesc;
        defaultSelectedVM = defaultOneClickVMsByDesc[0];
      } else {
        // display all VMs and preselect the default one
        defaultSelectedVM = defaultOneClickVMsByDesc[0];
      }
    } else {
      // nothing matches
      if (flags.enableHideUnselectedOneClickVms) {
        // hide all VMs
        filteredVMs = [];
        defaultSelectedVM = null;
      } else {
        defaultSelectedVM = filteredVMs[0];
      }
    }
  }

  if (!filteredVMs.length) {
    // no need to display this component is no VM on the list
    return <></>;
  }

  if (
    !selectedByAgent &&
    defaultSelectedVM &&
    defaultSelectedVM.name !== dropupName
  ) {
    setDropupName(defaultSelectedVM.name);
    setDropupType(defaultSelectedVM.type);
    setRecordingId(defaultSelectedVM.id);
  }

  const handleMenuClick = e => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = e => {
    e.preventDefault();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (e, name, type, id) => {
    e.preventDefault();
    console.log('selected vm: ', name, type, id);
    setDropupName(name);
    setDropupType(type);
    setRecordingId(id);
    setAnchorEl(null);
    setSelectedByAgent(true);
  };

  return (
    <>
      {true && (
        <>
          {errorState.play_vm && (
            <div
              className={styles.error}
              onClick={e => {
                deleteErrorMsg({ error_type: 'play_vm' });
              }}
            >
              <ErrorIcon className={styles.error_icon} />
              <div className={styles.error_msg}>{errorState.play_vm}</div>
            </div>
          )}
          {showVM && (
            <div className={styles.vm_container}>
              <div className={styles.vm_dropup_wrapper}>
                <div className={styles.vm_dropup_name}>
                  {dropupName || dropupType}
                </div>
                <DropUp
                  onClick={handleMenuClick}
                  className={styles.vm_dropup_icon}
                />
              </div>

              <Menu
                id="vm-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {filteredVMs.map(vm => {
                  if (vm.url)
                    return (
                      <StyledMenuItem
                        key={vm.name}
                        onClick={e =>
                          handleMenuItemClick(e, vm.name, vm.type, vm.id)
                        }
                      >
                        {vm.name}
                      </StyledMenuItem>
                    );
                })}
              </Menu>
              <div className={styles.leave_vm_wrapper}>
                <div className={styles.leave_vm_msg}>Leave message</div>
                {leaveButtonLoading ? (
                  <Spinner size={20} />
                ) : (
                  <LeaveVM
                    className={styles.leave_vm_icon}
                    onClick={async e => {
                      console.log('Leave msg', recordingId);
                      setleaveButtonLoading(true);
                      await services
                        .playVMRecording({
                          recording_id: recordingId,
                          task_id: task.id,
                        })
                        .then(res => setleaveButtonLoading(false))
                        .catch(err => {
                          console.error('Error while playing VM', err);
                          setleaveButtonLoading(false);
                          updateErrorMsg({
                            error_msg: `Error while playing VM`,
                            error_type: 'play_vm',
                          });
                        });
                    }}
                  />
                )}
              </div>

              <div className={styles.timer}>
                <Timer
                  initialTime={countdown}
                  direction="backward"
                  checkpoints={[
                    {
                      time: 0,
                      callback: () => {
                        console.log('Timer end');
                        setShowVM(false);
                      },
                    },
                  ]}
                >
                  <Timer.Minutes
                    formatValue={value => (value == 0 ? null : `${value}m`)}
                  />
                  <Timer.Seconds
                    formatValue={value => (value == 0 ? null : `${value}s`)}
                  />
                </Timer>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    vmState: state.vmState,
    errorState: state.errorState,
    countdown:
      (state.integrationState.recording_cant_be_played_after || 30) * 1000,
    userTelephonyProvider: state.userState.telephonyProvider,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateErrorMsg: ({ error_msg, error_type }) => {
      dispatch(updateErrorMsg({ error_msg, error_type }));
    },
    deleteErrorMsg: ({ error_type }) => {
      dispatch(deleteErrorMsg({ error_type }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLDConsumer()(VM));
